export const ASSETS_HASH = Date.now();
